import InputRedux from "components/molecules/InputRedux";
import { ReduxFormField } from "components/molecules/ReduxFormFields";
import { email, required } from "utils/validate.util";

export { default } from "./ConfirmRefundFrom";

export const fields: ReduxFormField[] = [
  {
    name: "email",
    label: "Email",
    validate: [required, email],
    component: InputRedux,
    cellProps: { lg: 12 },
    InputProps: { type: "email" },
  },
  {
    name: "password",
    label: "Password",
    validate: [required],
    component: InputRedux,
    cellProps: { lg: 12 },
    InputProps: { showIcon: true, type: "password" },
  },
];
